import React from 'react';

import { colours } from '$lib/tailwind/colours.js';
import { useTheme } from '$contexts/theme.jsx';
import tailwindConfig from '../../../tailwind.config.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const StyleGuidePage = () => {
    const typeStyles = Object.entries(tailwindConfig.theme.typeStyles({ theme: () => {} }));

    const {
        setTheme,
        theme,
        validThemes
    } = useTheme();

    return (
        <main
            className={`bg-main-background theme-${theme}`}
            id='main-content'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='flex flex-col gap-60'>
                    <div>
                        <h1>Style Guide</h1>
                        <hr />
                    </div>

                    <div>
                        <h2>Grid</h2>
                        <hr />

                        <div className='h-screen col-wrapper flex flex-wrap'>
                            {[1,2,3,4,5,6,7,8,9,10,11,12].map((_itm, idx) => {
                                return (
                                    <div
                                        className='h-full w-1/12 col-padding'
                                        key={idx}>
                                        <div
                                            className='h-full'
                                            style={{ backgroundColor: '#e0e0e080' }} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div>
                        <h2>Typography</h2>
                        <hr />

                        <dl className='flex flex-col gap-16'>
                            {typeStyles.map((itm, idx) => {
                                return (
                                    <div key={idx}>
                                        <dd className={`type-style-${itm[0]}`}>The quick brown fox jumps over the lazy dog</dd>
                                        <dt>{itm[1].displayName}</dt>
                                    </div>
                                );
                            })}
                        </dl>
                    </div>

                    <div>
                        <h2>Colours</h2>
                        <hr />

                        <dl className='flex flex-col gap-32'>
                            {Object.entries(colours).map((group, idx) => {
                                // no need to render out other themes with same class names
                                if (idx > 1) { return; };

                                return (
                                    <div key={idx}>
                                        <h3>{group[0] === 'swatch' ? 'Colour Swatch' : 'Custom Tailwind Variables (selector top right)'}</h3>

                                        <dl className='flex flex-wrap'>
                                            {group[0] === 'swatch' ? (
                                                Object.entries(group[1]).map((item, jdx) => {
                                                    return (
                                                        <div
                                                            className='relative w-1/12 aspect-square'
                                                            key={jdx}>
                                                            <dd className='h-full w-full'>
                                                                <div className={`h-full w-full bg-${item[0]}`} />
                                                            </dd>
                                                            <dt>
                                                                <span
                                                                    className='absolute top-0 left-0 mix-blend-difference'
                                                                    style={{ filter: 'invert(1)' }}>
                                                                    {item[0]}
                                                                </span>
                                                            </dt>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                Object.keys(group[1]).map((key, kdx) => {
                                                    return (
                                                        <div
                                                            className='relative w-2/12 aspect-square'
                                                            key={kdx}>
                                                            <dd className='h-full w-full'>
                                                                <div className={`h-full w-full bg-${key}`} />
                                                            </dd>
                                                            <dt>
                                                                <span
                                                                    className='absolute top-0 left-0 mix-blend-difference'
                                                                    style={{ filter: 'invert(1)' }}>
                                                                    {key}
                                                                </span>
                                                            </dt>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </dl>
                                    </div>
                                );
                            })}
                        </dl>
                    </div>

                    <div>
                        <h2>Buttons</h2>
                        <hr />

                        <dl className='flex flex-col gap-32'>
                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-primary-filled'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-primary-filled button-primary-filled--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Primary Filled</dt>
                            </div>

                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-primary-transparent'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-primary-transparent button-primary-transparent--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Primary Transparent</dt>
                            </div>

                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-secondary-filled'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-secondary-filled button-secondary-filled--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Secondary Filled</dt>
                            </div>

                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-secondary-transparent'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-secondary-transparent button-secondary-transparent--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Secondary Transparent</dt>
                            </div>

                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-brand-filled'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-brand-filled button-brand-filled--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Brand Filled</dt>
                            </div>

                            <div>
                                <dd className='flex flex-wrap gap-10'>
                                    <div>
                                        <button
                                            className='button-brand-transparent'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className='button-brand-transparent button-brand-transparent--small'
                                            type='button'>
                                            LABEL
                                        </button>
                                    </div>
                                </dd>
                                <dt>Button Brand Transparent</dt>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>

            {/* here so tailwind doesn't strip out dynamically used classes */}
            <div className='hide'>
                <span className='type-style-1'></span>
                <span className='type-style-2'></span>
                <span className='type-style-3'></span>
                <span className='type-style-4'></span>
                <span className='type-style-5'></span>
                <span className='type-style-body-l'></span>
                <span className='type-style-body-r'></span>
                <span className='type-style-caption'></span>
                <span className='type-style-eyebrow'></span>
                <span className='type-style-form-body-r'></span>
                <span className='type-style-form-body-s'></span>
                <span className='bg-brand-400'></span>
                <span className='bg-brand-500'></span>
                <span className='bg-brand-700'></span>
                <span className='bg-button-brand-filled-background'></span>
                <span className='bg-button-brand-filled-background-hover'></span>
                <span className='bg-button-brand-filled-text'></span>
                <span className='bg-button-brand-filled-text-hover'></span>
                <span className='bg-button-brand-transparent-background'></span>
                <span className='bg-button-brand-transparent-background-hover'></span>
                <span className='bg-button-brand-transparent-text'></span>
                <span className='bg-button-brand-transparent-text-hover'></span>
                <span className='bg-button-primary-filled-background'></span>
                <span className='bg-button-primary-filled-background-hover'></span>
                <span className='bg-button-primary-filled-text'></span>
                <span className='bg-button-primary-filled-text-hover'></span>
                <span className='bg-button-primary-transparent-background'></span>
                <span className='bg-button-primary-transparent-background-hover'></span>
                <span className='bg-button-primary-transparent-text'></span>
                <span className='bg-button-primary-transparent-text-hover'></span>
                <span className='bg-button-secondary-filled-background'></span>
                <span className='bg-button-secondary-filled-background-hover'></span>
                <span className='bg-button-secondary-filled-text'></span>
                <span className='bg-button-secondary-filled-text-hover'></span>
                <span className='bg-button-secondary-transparent-background'></span>
                <span className='bg-button-secondary-transparent-background-hover'></span>
                <span className='bg-button-secondary-transparent-text'></span>
                <span className='bg-button-secondary-transparent-text-hover'></span>
                <span className='bg-filter-background'></span>
                <span className='bg-filter-background-hover'></span>
                <span className='bg-filter-border-active'></span>
                <span className='bg-filter-filled-text'></span>
                <span className='bg-filter-label'></span>
                <span className='bg-grey-dark-600'></span>
                <span className='bg-grey-dark-700'></span>
                <span className='bg-grey-dark-800'></span>
                <span className='bg-grey-dark-900'></span>
                <span className='bg-grey-grey-0'></span>
                <span className='bg-grey-grey-100'></span>
                <span className='bg-grey-grey-200'></span>
                <span className='bg-grey-grey-300'></span>
                <span className='bg-grey-grey-400'></span>
                <span className='bg-grey-grey-50'></span>
                <span className='bg-grey-grey-950'></span>
                <span className='bg-grey-grey-transparent'></span>
                <span className='bg-input-background'></span>
                <span className='bg-input-border'></span>
                <span className='bg-input-border-active'></span>
                <span className='bg-input-filled-text'></span>
                <span className='bg-input-label'></span>
                <span className='bg-main-background'></span>
                <span className='bg-main-background-alt'></span>
                <span className='bg-main-background-brand'></span>
                <span className='bg-main-border'></span>
                <span className='bg-main-brand-text'></span>
                <span className='bg-main-logo'></span>
                <span className='bg-main-text-primary'></span>
                <span className='bg-main-text-secondary'></span>
                <span className='bg-nav-item-divider'></span>
                <span className='bg-nav-item-underline'></span>
                <span className='bg-sand-200'></span>
                <span className='bg-system-fail'></span>
                <span className='bg-system-fail-200'></span>
                <span className='bg-system-success'></span>
                <span className='bg-system-success-200'></span>
                <span className='bg-tab-background'></span>
                <span className='bg-tab-background-hover'></span>
                <span className='bg-tab-background-selected'></span>
                <span className='bg-tab-border'></span>
                <span className='bg-tab-border-hover'></span>
                <span className='bg-tab-border-selected'></span>
                <span className='bg-tab-text'></span>
                <span className='bg-tab-text-hover'></span>
                <span className='bg-tab-text-selected'></span>
                <span className='bg-tag-main-background'></span>
                <span className='bg-tag-main-background-hover'></span>
                <span className='bg-tag-main-background-selected-brand'></span>
                <span className='bg-tag-main-background-selected-primary'></span>
                <span className='bg-tag-main-background-selected-secondary'></span>
                <span className='bg-tag-main-border'></span>
                <span className='bg-tag-main-border-hover'></span>
                <span className='bg-tag-main-border-selected'></span>
                <span className='bg-tag-main-text'></span>
                <span className='bg-tag-main-text-hover'></span>
                <span className='bg-tag-main-text-selected'></span>
                <span className='bg-tag-price-background'></span>
                <span className='bg-tint-dark-10'></span>
                <span className='bg-tint-dark-15'></span>
                <span className='bg-tint-dark-20'></span>
                <span className='bg-tint-dark-40'></span>
                <span className='bg-tint-dark-60'></span>
                <span className='bg-tint-dark-80'></span>
                <span className='bg-tint-dark-90'></span>
                <span className='bg-tint-light-10'></span>
                <span className='bg-tint-light-15'></span>
                <span className='bg-tint-light-20'></span>
                <span className='bg-tint-light-40'></span>
                <span className='bg-tint-light-60'></span>
                <span className='bg-tint-light-80'></span>
                <span className='bg-tint-light-90'></span>
                <span className='bg-tooltip-background'></span>
                <span className='bg-tooltip-icon'></span>
            </div>

            <div className='fixed top-0 right-0'>
                <select
                    defaultValue={theme}
                    id='frm-theme-selector'
                    name='theme-selector'
                    onChange={(e) => setTheme(e.target.value)}>
                    {validThemes.map((opt ,idx) => {
                        return (
                            <option
                                key={idx}
                                value={opt}>
                                theme-{opt}
                            </option>
                        );
                    })}
                </select>
            </div>
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StyleGuidePage;
